import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import {useNavigate} from "react-router-dom";
import AppRoutes from "./../../routes.js";
import { actionTypes } from './../../store';
import './sign.css';

export default function Sign(){
    // Monitora o estado de 'data' e 'currentId'
    const data = useSelector((state) => state.finish);
    const [embedSrc, setEmbedSrc] = useState('');
    const currentId = useSelector((state) => state.currentId);

    console.log("Verificando useDispatch...");
    const dispatch = useDispatch(); // Verificar se o dispatch foi corretamente inicializado
    console.log("Dispatch inicializado: ", dispatch);

    console.log("Verificando useNavigate...");
    let navigate = useNavigate(); // Verificar se navigate foi corretamente inicializado
    console.log("Navigate inicializado: ", navigate);
    console.log("Initial Data (before useEffect): ", data);

    // Função para obter a URL do iFrame com o documento para assinar
    function getEmbed(id, email, tryFix = false){
        const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafariBrowser || tryFix) {
            const host = 'https://secure.d4sign.com.br/embed/safari_fix';
            const url_embed = `https://secure.d4sign.com.br/embed/viewblob/${id}`;
            const src = `${host}?param=email=${email}&display_name=&documentation=&birthday=&disable_preview=0&r=${url_embed}`;
            console.log("Safari Embed URL:", src);  // Depuração Safari
            return src;
        } else {
            const host = "https://secure.d4sign.com.br/embed/viewblob";
            const src = `${host}/${id}?email=${email}&display_name=&documentation=&birthday=&disable_preview=0`;
            console.log("Standard Embed URL:", src);  // Depuração padrão
            return src;
        }
    }

    // useEffect para gerenciar mensagens recebidas do iFrame
    useEffect(() => {
        const messageHandler = (event) => {
            console.log("Received Message Event: ", event);  // Depuração de mensagens do iFrame
            console.log("Event Data: ", event.data);
            
            if (event.data === "signed") {
                console.log("Document Signed, dispatching success status...");
                dispatch({type: actionTypes.set_status, payload: 'success'});
                dispatch({type: actionTypes.set_currentId, payload: currentId + 1});
                if (data['uuid_documents'].length > currentId) {
                    setEmbedSrc(getEmbed(data['uuid_documents'][currentId], data?.email));
                }
            }
            if (event.data === "wrong-data") {
                console.log("Error in data, dispatching error status...");
                dispatch({type: actionTypes.set_status, payload: 'error'});
            }
            if ((event.data === "signed" || event.data === "wrong-data") && data['uuid_documents'].length === currentId) {
                console.log("Navigating to finish route...");
                navigate(AppRoutes.finish);
            }
        };

        window.addEventListener("message", messageHandler, false);

        return () => {
            window.removeEventListener("message", messageHandler);
        };
    }, [data, currentId, dispatch, navigate]);

    // useEffect para verificar o estado de 'data' e configurar o embedSrc
    useEffect(() => {
        console.log("Current Data: ", data);  // Verificação inicial do estado de 'data'
        if (!data || !data['uuid_documents']) {
            console.log("Data is missing, navigating to root...");
            navigate("/");
        } else {
            console.log("Data is valid, setting embed source...");
            setEmbedSrc(getEmbed(data['uuid_documents'][currentId], data?.email));
        }
    }, [data, currentId, navigate]);

    // Renderização condicional baseada na existência de 'data' e 'uuid_documents'
    if (data && data['uuid_documents']) {
        return (
            <div className="sign">
                <div className="msg-alert">
                    <p>Caso esteja com problemas para visualizar o documento, acesse pelo link enviado para seu e-mail ou</p>
                    <button id="signButton" onClick={() => setEmbedSrc(getEmbed(data['uuid_documents'][currentId], data?.email, true))}>
                        Clique aqui caso o formulário não carregue
                    </button>
                </div>
                <b className="w-100 d-block text-center">Documentos para assinar: {currentId + 1} de {data['uuid_documents'].length}</b>
                <iframe key="d4signIframe" id="d4signIframe" src={embedSrc}></iframe>
            </div>
        );
    } else {
        console.log("No data available for rendering...");
        return (<></>);
    }
}
